import {
  CONFIRMED_GET_MEDICINE_STARTED,
  CONFIRMED_GET_PRESCRIPTION_EXPLAINED,
  CONFIRMED_GET_SERVICE_CALLER_SUMMARY,
  CONFIRMED_ADD_REMINDER,
  CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST,
  CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS,
  CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE,
  GET_SCHEDULED_LIST,
  GET_ANSWER_LIST_REQUEST,
  GET_ANSWER_LIST_SUCCESS,
  GET_ANSWER_LIST_FAILURE,
  ADD_NOTE_REQUEST,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_FAILURE,
} from "../types/ServiceFollowUpTypes";

import {
  getAnswerList,
  getMedicineStarted,
  getPrescriptionExplained,
  getPrescriptionSummary,
  addFollowupDelay,
  addReminder,
  getScheduledList,
  generateFollowupId,
  addFollowup,
  getFollowupList,
  addNote,
  discardFollowupId,
  sendScheduled
} from "../../services/ServiceFollowUpService";

export const getMedicineStartedAction = (
  prescription_id,
  medicine_started,
  medicine_started_date
) => {
  return async (dispatch) => {
    try {
      const response = await getMedicineStarted(
        prescription_id,
        medicine_started,
        medicine_started_date
      );
      console.log("Medicine Started API Response:", response);

      dispatch({
        type: CONFIRMED_GET_MEDICINE_STARTED,
        payload: response?.data || {},
      });
      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error in getMedicineStartedAction:", error);
      throw error;
    }
  };
};

export const getPrescriptionExplainedAction = (
  prescription_id,
  prescription_explained,
  prescription_explained_date
) => {
  return async (dispatch) => {
    try {
      const response = await getPrescriptionExplained(
        prescription_id,
        prescription_explained,
        prescription_explained_date
      );
      console.log("Prescription Explained API Response:", response);

      dispatch({
        type: CONFIRMED_GET_PRESCRIPTION_EXPLAINED,
        payload: response?.data || {},
      });

      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error in getPrescriptionExplainedAction:", error);
      throw error;
    }
  };
};

export function getPrescriptionSummaryAction(patient_id) {
  return async (dispatch, getState) => {
    try {
      const response = await getPrescriptionSummary(patient_id);
      console.log("API Response:", response);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_SERVICE_CALLER_SUMMARY,
          payload: response.data.data,
        });
      } else {
        showErrorAlert(
          "Oops",
          response?.data?.message || "Failed to get patient details"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert("Oops", error.message || "Failed to get patient details");
    }
  };
}

export const getAnswerListAction = (patientId, date = null) => {
  return async (dispatch) => {
    dispatch({ type: GET_ANSWER_LIST_REQUEST });

    try {
      const response = await getAnswerList(patientId, "No", date);
      dispatch({
        type: GET_ANSWER_LIST_SUCCESS,
        payload: response.data,
      });
      return response;
    } catch (error) {
      dispatch({
        type: GET_ANSWER_LIST_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
};

export const addReminderAction = ({
  patient_id,
  prescription_id,
  reminder_date,
  reminder_time,
}) => {
  return async (dispatch) => {
    try {
      const response = await addReminder({
        patient_id,
        prescription_id,
        reminder_date,
        reminder_time,
      });

      console.log("Add Reminder API Response:", response);

      dispatch({
        type: CONFIRMED_ADD_REMINDER,
        payload: {
          data: response?.data || {},
          success: true,
          error: null,
        },
      });

      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error adding reminder:", error);

      dispatch({
        type: CONFIRMED_ADD_REMINDER,
        payload: {
          data: {},
          success: false,
          error: error?.response?.data?.message || error.message,
        },
      });

      return {
        success: false,
        error: error?.response?.data?.message || "Something went wrong",
      };
    }
  };
};

export const addFollowupDelayAction = ({ schedule_id, delay_days }) => {
  return async (dispatch) => {
    dispatch({ type: CONFIRMED_ADD_FOLLOWUP_DELAY_REQUEST });

    try {
      const response = await addFollowupDelay({ schedule_id, delay_days });
      console.log("Add Follow-up Delay API Response:", response);

      dispatch({
        type: CONFIRMED_ADD_FOLLOWUP_DELAY_SUCCESS,
        payload: {
          data: response?.data || {},
          success: true,
          error: null,
        },
      });

      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error adding follow-up delay:", error);

      dispatch({
        type: CONFIRMED_ADD_FOLLOWUP_DELAY_FAILURE,
        payload: {
          data: {},
          success: false,
          error: error?.response?.data?.message || error.message,
        },
      });

      return {
        success: false,
        error: error?.response?.data?.message || "Something went wrong",
      };
    }
  };
};

export const getScheduledListAction = (prescription_id) => {
  return async (dispatch) => {
    try {
      const response = await getScheduledList(prescription_id);
      console.log("Scheduled List API Response:", response);
      dispatch({
        type: GET_SCHEDULED_LIST,
        payload: {
          data: response?.data || {},
          error: null,
          success: true,
        },
      });
      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error fetching scheduled list:", error);
      dispatch({
        type: GET_SCHEDULED_LIST,
        payload: {
          data: {},
          error: error?.response?.data?.message || error.message,
          success: false,
        },
      });

      return {
        success: false,
        error: error?.response?.data?.message || "Something went wrong",
      };
    }
  };
};

export const GENERATE_FOLLOWUP_ID_REQUEST = "GENERATE_FOLLOWUP_ID_REQUEST";
export const GENERATE_FOLLOWUP_ID_SUCCESS = "GENERATE_FOLLOWUP_ID_SUCCESS";
export const GENERATE_FOLLOWUP_ID_FAILURE = "GENERATE_FOLLOWUP_ID_FAILURE";

export const generateFollowupIdAction = ({ prescription_id, patient_id }) => {
  return async (dispatch) => {
    dispatch({ type: GENERATE_FOLLOWUP_ID_REQUEST });
    try {
      const response = await generateFollowupId(prescription_id, patient_id);
      dispatch({
        type: GENERATE_FOLLOWUP_ID_SUCCESS,
        payload: response.data,
      });
      return response;
    } catch (error) {
      dispatch({
        type: GENERATE_FOLLOWUP_ID_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
};

export const ADD_FOLLOWUP_REQUEST = "ADD_FOLLOWUP_REQUEST";
export const ADD_FOLLOWUP_SUCCESS = "ADD_FOLLOWUP_SUCCESS";
export const ADD_FOLLOWUP_FAILURE = "ADD_FOLLOWUP_FAILURE";

export const addFollowupAction = (followupData) => {
  return async (dispatch) => {
    dispatch({ type: ADD_FOLLOWUP_REQUEST });
    try {
      const response = await addFollowup(followupData);
      console.log("Add Followup API Response:", response);

      if (response.status === "success") {
        dispatch({
          type: ADD_FOLLOWUP_SUCCESS,
          payload: response.data,
        });
        return {
          ...response,
          success: true,
        };
      } else {
        throw new Error(response.message || "Failed to add followup");
      }
    } catch (error) {
      console.error("Error in addFollowupAction:", error);
      dispatch({
        type: ADD_FOLLOWUP_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
};

export const GET_FOLLOWUP_LIST_REQUEST = "GET_FOLLOWUP_LIST_REQUEST";
export const GET_FOLLOWUP_LIST_SUCCESS = "GET_FOLLOWUP_LIST_SUCCESS";
export const GET_FOLLOWUP_LIST_FAILURE = "GET_FOLLOWUP_LIST_FAILURE";

export const getFollowupListAction = (prescription_id) => {
  return async (dispatch) => {
    dispatch({ type: GET_FOLLOWUP_LIST_REQUEST });
    try {
      const response = await getFollowupList(prescription_id);
      console.log("API Response:", response);
      if (response.status === "success") {
        dispatch({
          type: GET_FOLLOWUP_LIST_SUCCESS,
          payload: response,
        });
        return response;
      } else {
        throw new Error(response.message || "Failed to fetch followup list");
      }
    } catch (error) {
      console.error("Error in getFollowupListAction:", error);
      dispatch({
        type: GET_FOLLOWUP_LIST_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
};

export const addNoteAction = (noteData) => {
  return async (dispatch) => {
    dispatch({ type: ADD_NOTE_REQUEST });

    try {
      // Format the request payload
      const payload = {
        patient_id: noteData.patient_id ? noteData.patient_id : "0",
        note_description: noteData.note_description,
        followup_id: noteData.followup_id || "0",
        note_type: "Service Caller",
        sub_role: JSON.stringify([]), // Default roles as per API requirement
        prescription_id: noteData.prescription_id || "0",
        is_important: noteData.is_important,
        is_emergency: noteData.is_emergency,
        doctor_id: noteData.doctor_id || "0",
      };

      const response = await addNote(payload);
      console.log("Note API Response:", response);

      if (response.status === "success") {
        dispatch({
          type: ADD_NOTE_SUCCESS,
          payload: {
            ...response.data,
            created_by_name: noteData.created_by_name || "Unknown",
            profile_image:
              noteData.profile_image ||
              "https://opd-dev.softdienst.in/public/uploads/UserIcon.png",
          },
        });

        return {
          status: response.status,
          message: response.message,
          data: response.data,
        };
      } else {
        throw new Error(response.message || "Failed to add note");
      }
    } catch (error) {
      console.error("Error adding note:", error);

      dispatch({
        type: ADD_NOTE_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });

      throw error;
    }
  };
};

export const DISCARD_FOLLOWUP_REQUEST = "DISCARD_FOLLOWUP_REQUEST";
export const DISCARD_FOLLOWUP_SUCCESS = "DISCARD_FOLLOWUP_SUCCESS";
export const DISCARD_FOLLOWUP_FAILURE = "DISCARD_FOLLOWUP_FAILURE";

export const discardFollowupAction = (followup_id) => {
  return async (dispatch) => {
    dispatch({ type: DISCARD_FOLLOWUP_REQUEST });
    try {
      const response = await discardFollowupId(followup_id);
      dispatch({
        type: DISCARD_FOLLOWUP_SUCCESS,
        payload: response,
      });
      return response;
    } catch (error) {
      dispatch({
        type: DISCARD_FOLLOWUP_FAILURE,
        payload: error.message,
      });
      throw error;
    }
  };
};

export const sendScheduledAction = ({ patient_id, prescription_id }) => {
  return async () => {
    try {
      const response = await sendScheduled(patient_id, prescription_id);

      console.log("Send Scheduled API Response:", response);

      return {
        ...response?.data,
        success: true,
      };
    } catch (error) {
      console.error("Error in sendScheduledAction:", error);

      return {
        success: false,
        error: error?.response?.data?.message || error.message,
      };
    }
  };
};
